// Detects the user's OS from userAgent so /download can highlight the right platform.
export function detectOS() {
  if (typeof window === 'undefined') return 'web';
  const ua = navigator.userAgent || '';
  const platform = navigator.platform || '';
  if (/iPhone|iPad|iPod/i.test(ua)) return 'ios';
  if (/Android/i.test(ua)) return 'android';
  if (/Win/i.test(platform)) return 'windows';
  if (/Mac/i.test(platform)) return 'macos';
  if (/Linux/i.test(platform)) return 'linux';
  return 'web';
}

export function osLabel(os) {
  return { ios: 'iOS', android: 'Android', windows: 'Windows', macos: 'macOS', linux: 'Linux', web: 'Web' }[os] || 'Web';
}
